// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ez-0";
export var actionModalContentContainer = "_ez-1";
export var createTagButton = "_ez-2";
export var footerContainer = "_ez-7";
export var fullWidthDivider = "_ez-3";
export var hasCreateTagButton = "_ez-4";
export var noCreateTagButton = "_ez-5";
export var tagsContainer = "_ez-6";
export var tagsModalContentContainer = "_ez-8";